import { combineActions, handleActions } from 'redux-actions'
import { fromJS, isImmutable } from 'immutable'

import * as Actions from 'actions/journalists'
import * as AppActions from 'actions/app'

export const initialState = fromJS({
  query: '',
  firstName: '',
  lastName: '',
  jobTitles: [],
  countries: [],
  states: [],
  languages: [],
  iptcMediaTopics: [],
  tags: [],
  mediaTypes: [],
  publicationIds: [],
  channels: [],
  includeContacts: false
})

export default handleActions({
  [Actions.setQuery]: (state, { payload }) => state.set('query', payload),
  [Actions.setFilter]: (state, { payload }) => {
    const { key, value } = payload
    const immutableValue = isImmutable(value) ? value : fromJS(value)

    if ((key === 'channels' || key === 'mediaTypes') && !immutableValue.isEmpty()) {
      return state.set(key, immutableValue).set('publicationIds', fromJS([]))
    }

    return state.set(key, immutableValue)
  },
  [Actions.setIptcMediaTopicFilter]: (state, { payload }) => state.update('iptcMediaTopics', iptcMediaTopics => {
    if (iptcMediaTopics.includes(payload)) {
      return iptcMediaTopics.filterNot(i => i === payload)
    }

    return iptcMediaTopics.push(payload)
  }),
  [combineActions(
    Actions.clearFilters,
    AppActions.resetState
  )]: () => initialState
}, initialState)
